import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { queryKeys } from '@/core/data-fetching/queryKeys';
import { useErrorToast } from '@/core/errors/useErrorToast';
import { modulePackagesService, type ModulePackageDraft } from '../api/module-packages.service';

export function useModulePackages() {
  return useQuery({ queryKey: queryKeys.modulePackages, queryFn: modulePackagesService.list });
}
export function useModulePackageCatalog() {
  return useQuery({ queryKey: queryKeys.plans.capabilities, queryFn: modulePackagesService.catalog });
}
export function useSaveModulePackage() {
  const qc = useQueryClient();
  const onError = useErrorToast();
  return useMutation({ mutationFn: ({ id, input }: { id: string | null; input: ModulePackageDraft }) => modulePackagesService.save(id, input),
    onSuccess: async () => { await Promise.all([qc.invalidateQueries({ queryKey: queryKeys.modulePackages }), qc.invalidateQueries({ queryKey: queryKeys.plans.all }), qc.invalidateQueries({ queryKey: queryKeys.companies.all })]); toast.success('Pacote de módulos salvo.'); },
    onError: (error) => onError(error, 'Não foi possível salvar o pacote. Atualize a lista e tente novamente.'),
  });
}
